export default {
    setRecentAction(context, payload) {
        context.recentAction = payload;
    }
}